module.exports = __webpack_public_path__ + "static/ipad-iphone-mobile-c3eb8f46d1fc2d7ba74de0b500ed2475.png";